<script>
import { mapGetters } from 'vuex'

import Translatable from '@src/mixins/translatable.js'
import SanitizerMixin from '@src/mixins/sanitizer-mixin.js'

export default {
  mixins: [
    Translatable,
    SanitizerMixin
  ],
  computed : {
    ...mapGetters('home', [
      'pageData',
    ]),
    ...mapGetters('translations', [
      'currentLanguage'
    ]),
    benefitsData() {
      if (this.pageData.content) {
        return this.pageData.content[this.currentLanguage].benefits.items[0].title ?
        this.pageData.content[this.currentLanguage].benefits.items : this.pageData.content.en.benefits.items
      }
      return []
    }
  },
  methods: {
    toggleSpoiler(event) {
      const activeSpoilers = document.querySelectorAll('.spoiler-content.active')
      activeSpoilers.forEach((spoiler) => {
        spoiler.classList.toggle('active')
      })
      const spoilerContent = event.currentTarget.parentNode.querySelector('.spoiler-content')
      spoilerContent.classList.toggle('active')
    }
  },
  mounted() {
    // Set the first spoiler visible by default
    const firstSpoiler = document.querySelector('.spoiler-content')
    firstSpoiler.classList.toggle('active')
  }
}
</script>

<template>
  <div class="content">
    <div v-for="(benefit, index) in benefitsData" :key="index" class="spoiler">
      <div class="spoiler-title-box" @click.prevent="toggleSpoiler">
        <h4 class="spoiler-title-text" v-html="benefit.title">
        </h4>
      </div>
      <div class="spoiler-content hidden">
        <p class="spoiler-text" v-html="textSanitize(benefit.text)">
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.content {
  height: auto;
}

.spoiler-title-box {
  cursor: pointer;
  width: 656px;
  height: 90px;
  background-color: $dark-blue;
  display: flex;
  align-items: center;

  &:hover {
    background-color: $hover-blue;
  }
}

.spoiler {
  margin-top: 2px;
}

.spoiler:first-child {
  margin-top: 0;
}

.spoiler-title-text {
  margin-left: 20px;
  font-family: Open Sans Semibold, sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  text-transform: uppercase;
  color: #FFFFFF;
}

.spoiler-content {
  height: 0;
  visibility: hidden;
  background: #F9F9FB;
  transition: height 0.25s ease-out;
  display: flex;
  justify-content: left;
  padding-left: 20px;
}

.active {
  height: auto;
  visibility: visible;
}

::v-deep.spoiler-text {
  width: 616px;
  margin: 15px 0;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: #252527;
  user-select: none;

  & em {
    font-style: italic;
  }

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }

  & .ql-align-center {
    text-align: center;
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .spoiler-text,
  .spoiler-title-box,
  .spoiler {
    width: 100%;
  }

  .spoiler-title-box {
    height: 90px;
    display: flex;
    justify-content: center;

    &:hover {
      background-color: $dark-blue;
    }
  }

  .spoiler-title-text {
    margin: 0;
    padding-left: 8px;
    padding-right: 8px;
    font-size: 16px;
    line-height: 130%;
    text-align: center;
  }

  .spoiler-content {
    padding-right: 8px;
    padding-left: 8px;
  }

  .active {
    height: auto;
  }

  .spoiler-text {
    margin: 10px 0;
  }
}
</style>
